<template>
    <div class="container">
      <div class="row">
        <TitleArea :title="title" v-if="title"/>
        <div class="col-12 position-relative map-container" v-if="latitude && longitude">
          <iframe 
            class="map-iframe shadow mb-5 bg-body rounded"
            :src="`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`"
            allowfullscreen>
          </iframe>
          <div class="position-absolute top-0 end-0">
            <a
              :href="`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`"
              class="btn shadow mapButton"
              target="_blank">
              Rruga
            </a>
          </div>
        </div>
        <div class="row mt-4">
          <div
            class="col-lg-6 col-md-12 col-sm-12 mb-4"
            v-for="(card, index) in contactCards"
            :key="index">
            <div class="card shadow-sm bg-body rounded">
              <div class="card-header fw-bold">{{ card.title }}</div>
              <div class="card-body">
                <ul>
                  <li v-for="(item, i) in card.items" :key="i">
                    <div class="d-flex">
                      <!-- Label jashtë labelBox - shfaqet vetëm kur i === 0 -->
                      <label v-if="i === 0" :class="{ 'first-label': i === 0 }">
                          <font-awesome-icon 
                            v-if="item.icon && i !== 0" 
                            :icon="item.icon" 
                            class="icon" />
                          <strong>{{ item.label }}</strong>
                      </label>
                      <div class="labelBox">
                         <!-- Label brenda labelBox - shfaqet vetëm kur i !== 0 -->
                         <label v-if="i !== 0" :class="{ 'first-label': i === 0 }">
                          <font-awesome-icon 
                            v-if="item.icon && i !== 0" 
                            :icon="item.icon" 
                            class="icon" />
                          <strong>{{ item.label }}:</strong>
                        </label>
                      </div>
                      <div>
                        <p v-if="item.label === 'Tel/Fix'">
                          <a :href="`tel:${item.value}`" class="text-primary">{{ item.value }}</a>
                        </p>
                        <p
                          v-else-if="
                            item.label === 'Email' ||
                            item.label === 'Email Zyrtar'">
                          <a :href="`mailto:${item.value}`" class="text-primary" v-html="item.value"></a>
                        </p>
                        <p v-else>
                          {{ item.value }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import TitleArea from "@/components/share/TitleArea.vue";
  
  export default {
    name: "ContactMap",
    components: { TitleArea },
    props: {
      title: { type: String, default: "" },
      latitude: { type: Number, required: true },
      longitude: { type: Number, required: true },
      contactCards: { type: Array, required: true }
    }
  };
  </script>
  
  <style scoped>
  .map-container {
    width: 100%;
    height: 400px;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .map-iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
  
  .mapButton {
    background-color: var(--color-system-primary) !important;
  }
  
  .mapButton:hover {
    background-color: var(--color-system-primary) !important;
    color: white;
  }
  
  ul li {
    list-style: none;
  }
  
  ul li a {
    text-decoration: none;
    color: inherit;
  }
  
  .labelBox {
    width: 150px !important;
  }
  
  .icon {
    width: 25px;
  }

  .first-label{
    font-size:18px;
  }
  </style>
  